<script lang="ts" setup>
import type { Context } from '../../types/content'

const contextsStore = useContextsStore()

const { t } = useI18n()
const toast = useToast()
const { openConfirmation } = useConfirmation()

const isOpen = computed({
  get: () => contextsStore.isSwitchingContexts,
  set: (value) => {
    if (!value) {
      contextsStore.clearPendingMove()
    } else {
      contextsStore.isSwitchingContexts = value
    }
  }
})

const isCurrentContext = (context: Context) =>
  context.id === contextsStore.currentContext?.id

async function handleSelectContext(context: Context) {
  const pending = contextsStore.pendingMove
  if (!pending) return

  contextsStore.isSwitchingContexts = false

  const confirmed = await openConfirmation({
    title: t('move_confirmation_title', { context: context.name }),
    description: t('move_confirmation_description', {
      count: pending.ids.length,
      context: context.name
    })
  })

  if (!confirmed) {
    contextsStore.clearPendingMove()
    return
  }

  await contextsStore.moveContentToContext(pending.type, pending.ids, context)

  toast.add({
    title: t('moved_successfully'),
    icon: 'i-mingcute-check-line'
  })

  contextsStore.clearPendingMove()
}
</script>

<template>
  <ResponsiveDialog v-model="isOpen">
    <ul class="space-y-2">
      <li v-for="context in contextsStore.contexts" :key="context.id">
        <UButton
          variant="solid"
          size="xl"
          class="w-full flex text-inverted items-center justify-between gap-2"
          :disabled="isCurrentContext(context)"
          :style="{
            backgroundColor: `var(--color-context-${context.color})`
          }"
          @click="handleSelectContext(context)"
        >
          <span class="flex-1 truncate text-left">
            {{ context.name }}
          </span>
          <UIcon
            v-if="isCurrentContext(context)"
            name="i-mingcute-check-line"
            class="ml-auto"
            size="24"
          />
        </UButton>
      </li>
    </ul>
  </ResponsiveDialog>
</template>
